import { render } from "./HomePageDeals.vue?vue&type=template&id=06278681&scoped=true"
import script from "./HomePageDeals.vue?vue&type=script&lang=js"
export * from "./HomePageDeals.vue?vue&type=script&lang=js"

import "./HomePageDeals.vue?vue&type=style&index=0&id=06278681&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06278681"]])

export default __exports__